import { render, staticRenderFns } from "./Vedio.vue?vue&type=template&id=216b61d8&scoped=true"
import script from "./Vedio.vue?vue&type=script&lang=js"
export * from "./Vedio.vue?vue&type=script&lang=js"
import style0 from "./Vedio.vue?vue&type=style&index=0&id=216b61d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b61d8",
  null
  
)

export default component.exports